<template>
  <div>
    <el-table
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      :data="tableData"
      border
      style="width: 100%; margin-top: 10px"
      @row-dblclick="handleClickdisplay"
    >
      <el-table-column prop="JOBNO" label="单号" width="500"> </el-table-column>
      <el-table-column
        prop="QUANTITY"
        label="汇总册数"
        header-align="center"
        align="right"
        width="300"
      ></el-table-column>
      <el-table-column
        prop="Mayang"
        label="汇总码洋"
        header-align="center"
        align="right"
        width="300"
      ></el-table-column>
      <el-table-column
        label="操作"
        header-align="center"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <el-button
            @click="handleClickdisplay(scope.row)"
            type="text"
            size="small"
            v-show="bedit"
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from "axios";
import global from "../global.vue";
import AES from "../AES.js";

export default {
  data() {
    return {
      loading: false,
      slogid: "",
      sfilter: "",
      bedit: true,
      bbrow: false,
      tableData: [],
    };
  },
  created() {
    this.getdata();
  },
  mounted() {},
  methods: {
    handleClickdisplay(row) {
      this.$router.push({
        path: "/qtindex/deliverydetail",
        query: { jobno: row.JOBNO },
      });
    },

    getdata() {
      this.loading = true;

      let that = this;
      var stoken = window.localStorage.getItem("stoken");
      console.log(stoken);

      axios({
        headers: {
          "Content-type": "text/xml",
          token: stoken,
        },
        method: "post",
        url: global.sserverip + "getdeliverylistbyscustomerid",
        data: stoken,
      })
        .then(function (res) {
          //TO-DO 先判断下数据是否正确 status
          console.log(res.data);
          that.tableData = res.data;
          that.loading = false;
        })
        .catch(function (err) {
          console.log(err);
          that.loading = false;
        });
    },
  },
};
</script>


